import React from 'react';
import * as cls from './utilities.module.css';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../constants';
import Meta from '../../../components/meta';
import Hero from '../../ui/components/hero/hero';
import { Button } from '../../ui/components/button';
import { Section } from '../../ui/components/section';
import { Typography } from '../../ui/components/typography';
import { WhatItMeansToYou } from './what-it-means-to-you/what-it-means-to-you';
import { HowItWorks } from './how-it-works/how-it-works';
import { Benefits } from './benefits';
import { TransformCustomersExperience } from './transform-customers-experience';
import { ResultsAndCaseStudies } from './results-and-case-studies/results-and-case-studies';
import { TrustedBy } from './trusted-by/trusted-by';
import { PartnersReviews } from './partners-reviews/partners-reviews';

export const V2Utilities = () => {
  return (
    <>
      <Meta
        title="Utility Customer Engagement that Reduces Churn | Voltaware"
        description="Increase utility customer engagement, cut churn and call-centre costs, and unlock value-added services with appliance-level AI insights via dashboards, APIs and apps."
        image="https://voltaware.com/img/v2/utilities/utility-customer-engagement.svg"
      />

      <Hero
        className={cls.hero}
        items={[
          {
            img: `${IMG_PATH}/utilities/utility-customer-engagement.svg`,
            imgAlt:
              'Utility customer engagement dashboard and app with AI energy insights',
            title: (
              <>
                Utility Customer Engagement <span>as a Service</span>
              </>
            ),
            caption: (
              <>
                Engage customers. Reduce churn.
                <br />
                Unlock new revenue with AI energy insights.
              </>
            ),
            action: (
              <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
                <Button>Get Demo</Button>
              </Link>
            ),
          },
        ]}
      />

      <div className={cls['utilities-page']}>
        <Section classNameRoot={cls.intro}>
          <div>
            <Typography>
              <span>Voltaware helps</span> utilities engage customers, reduce
              churn, and accelerate the energy transition.
            </Typography>
            <Typography>
              <em>Our AI-driven</em> analytics turn smart-meter and sensor data
              into clear, actionable insights - delivered through smart bills,
              apps, or APIs.
            </Typography>
          </div>
        </Section>

        <WhatItMeansToYou />

        <HowItWorks />

        <Benefits />

        <TransformCustomersExperience />

        <ResultsAndCaseStudies />

        <Section classNameRoot={cls['section--green']}>
          <Typography className={cls['voltaware-flags']}>
            <span>
              In the UK, 35-40% of households have inefficient fridges.
              <br />
              <strong>Voltaware flags</strong> them for greener replacements
              with 5-year ROl.
            </span>
          </Typography>
          <Typography>
            <img alt="" src={`${IMG_PATH}/utilities/voltaware-logo.svg`} />
            <span>
              <strong>Voltaware</strong> also <b>expands</b> into other
              appliances like air conditioners.
            </span>
          </Typography>
        </Section>

        <PartnersReviews />

        <TrustedBy />

        <Section
          classNameRoot={`${cls['section--green']} ${cls['section--green--last']}`}
        >
          <Typography>
            <img alt="" src={`${IMG_PATH}/utilities/voltaware-logo.svg`} />
            <span>
              We are covering <b>350,000</b> households since 2014.
            </span>
          </Typography>
        </Section>

        <Section backgroundContrast classNameRoot={cls['section__final-cta']}>
          <Typography as="h2" tag="h3">
            Ready to engage customers and unlock new revenue?
          </Typography>
          <Typography className={cls.footer__description}>
            <strong>Voltaware helps</strong> utilities cut costs, retain
            customers, and grow profitability -{' '}
            <strong>with customer engagement software for utilities.</strong>
          </Typography>

          <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
            <Button>Request Demo</Button>
          </Link>
        </Section>
      </div>
    </>
  );
};
